class TrackingHelpers {
  public static getAppUtms() {
    const params = this.getUrlParameters();

    if (typeof params === 'string') {
      // Handle the unlikely case where params is a string, though it shouldn't happen here
      throw new Error('Unexpected string result from getUrlParameters');
    }

    let fbclid = params['fbclid'] || undefined;
    const fbclidParsed = fbclid
      ? String(fbclid)
          .replace(/[\[\]\'\"]/g, '')
          .split(',')
      : undefined;
    const isFbclidArray = fbclidParsed && Array.isArray(fbclidParsed);

    if (isFbclidArray) {
      fbclid = fbclidParsed[0];
    }

    const fbc = fbclid
      ? `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}`
      : undefined;
    const fbp = fbclid
      ? `fb.1.${Math.floor(Date.now() / 1000)}.${Math.floor(
          Math.random() * (1999999999 - 1000000000 + 1) + 1000000000,
        )}`
      : '';

    return {
      affId: params['affid'],
      custom_ttp: this.getCookie('_ttp') || undefined, // Assuming you have a getCookie method
      custom_fbc: fbc,
      custom_fbp: fbp,
      custom_fbclid: fbclid,
      custom_gclid: params['gclid'],
      custom_ttclid: params['ttclid'],
      custom_wbraid: params['wbraid'],
      custom_gbraid: params['gbraid'],
      custom_order_vlmid: params['vlmid'],
      custom_order_auid: params['utm_auid'],
      custom_ob_click_id: params['ob_click_id'],
      custom_gl: params['_gl'] || params['__gl'],
      custom_taboola_clid: params['taboola_clid'],
    };
  }

  // This function will return all parameters from the URL as an object
  public static getAllUrlParameters(): Record<string, string> {
    const urlParams = new URLSearchParams(window.location.search);
    const params: Record<string, string> = {};

    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }

    return params;
  }

  public static getUrlParameters(
    param?: string,
    fallback = '',
  ): Record<string, string> | string {
    const urlParams = new URLSearchParams(window.location.search);
    const params: Record<string, string> = {};

    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }

    if (typeof param === 'string' && param.length > 0) {
      return params[param] || fallback;
    }
    return params;
  }

  public static getBrowserInfo() {
    const userAgent = navigator.userAgent;
    let browserName = 'Unknown';
    let fullVersion = 'Unknown';

    if (userAgent.indexOf('Firefox') > -1) {
      browserName = 'Mozilla Firefox';
    } else if (
      userAgent.indexOf('Opera') > -1 ||
      userAgent.indexOf('OPR') > -1
    ) {
      browserName = 'Opera';
    } else if (userAgent.indexOf('Chrome') > -1) {
      browserName = 'Google Chrome';
    } else if (userAgent.indexOf('Safari') > -1) {
      browserName = 'Safari';
    } else if (userAgent.indexOf('MSIE') > -1 || !!document.DOCUMENT_NODE) {
      browserName = 'Internet Explorer';
    }

    const versionMatch = userAgent.match(
      /(chrome|firefox|opr|opera|safari|msie|trident(?=\/))\/?\s*(\d+)/i,
    );
    if (versionMatch && versionMatch.length > 2) {
      fullVersion = versionMatch[2];
    }

    return {
      browserName,
      fullVersion,
      userAgent,
    };
  }

  public static getScreenSize() {
    return {
      width: window.screen.width,
      height: window.screen.height,
      availableWidth: window.screen.availWidth,
      availableHeight: window.screen.availHeight,
    };
  }

  private static getCookie(key: string): string | null {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const [cookieName, cookieValue] = cookie.split('=');

      if (cookieName.trim() === key) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  }
}

export default TrackingHelpers;
